module.exports = __webpack_public_path__ + "media/images/category/feature/aoj_b/aoj_b-4-8c35bb087468901d1c97e73624e2ab60.jpg";